import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=1ed67c18&scoped=true"
import script from "./Tenants.vue?vue&type=script&lang=js"
export * from "./Tenants.vue?vue&type=script&lang=js"
import style0 from "./Tenants.vue?vue&type=style&index=0&id=1ed67c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed67c18",
  null
  
)

export default component.exports